import { EVENT_SET_FIELD_VALUE, publishEvent } from "../utils/events";

const groceryCrudSetFieldValue = (fieldName, fieldValue) => {
  publishEvent(EVENT_SET_FIELD_VALUE, {
    fieldName,
    fieldValue,
  });
};

if (window) {
  // Also make it available globally
  window.groceryCrudSetFieldValue = groceryCrudSetFieldValue;
}

export default groceryCrudSetFieldValue;
